export default "__VITE_ASSET__aabf9f38__"